import { beautifyKey } from "../string";

//Works for strings,arrays,objects
export function isEmpty(value: any) {
	return (
		value === undefined ||
		value === null ||
		(typeof value === "string" && value.trim() === "") ||
		(Array.isArray(value) && value.length === 0) ||
		(typeof value === "object" && Object.keys(value).length === 0)
	);
}

export function flattenObject(obj: any, parentKey: string) {
	const flattened: any = {};
	Object.keys(obj).forEach((key) => {
		const value = obj[key];
		//If value is of type object recursion
		if (typeof value === "object" && value !== null && !Array.isArray(value)) {
			Object.assign(flattened, flattenObject(value, beautifyKey(key)));
		}
		//Else add value to flattened object with key as (ParentKey)(ChildKey)
		else {
			if (parentKey) {
				flattened[`${parentKey}${beautifyKey(key)}`] = value;
			} else flattened[key] = value;
		}
	});
	return flattened;
}

export function compareObjects(a: any, b: any) {
	let s = (o: any) =>
		Object.entries(o)
			.sort()
			.map((i) => {
				if (i[1] instanceof Object) i[1] = s(i[1]);
				return i;
			});
	return JSON.stringify(s(a)) === JSON.stringify(s(b));
}

export function deepCopy(obj: any) {
	return JSON.parse(JSON.stringify(obj));
}

export function arrayEquals(arr1:any, arr2:any) {
	if(arr1.length !== arr2.length) return false;

	const arr2HasArr1Keys = arr2.every((value:any) => arr1.includes(value));
	if(!arr2HasArr1Keys) return false;

	const arr1HasArr2Keys = arr1.every((value:any) => arr2.includes(value));
	if(!arr1HasArr2Keys) return false;

	return true;
}

export function isEmptyObject(obj:any) {
	if(!obj) return true;
	for(var i in obj) {
		return false;
	}
	return true;
}